export const GET_LESSONS = "GET_LESSONS";
export const GET_PRONUNCIATION = "GET_PRONUNCIATION";
export const GET_TIPS = "GET_TIPS";
export const GET_LESSON = "GET_LESSON";
export const NEXT_LESSON = "NEXT_LESSON";
export const PREV_LESSON = "PREV_LESSON";
export const COUNT_LESSONS = "COUNT_LESSONS";
export const FILTER_LESSON = "FILTER_LESSON";
export const FILTER_TIPS = "FILTER_TIPS";
export const FILTER_PRONUNCIATION = "FILTER_PRONUNCIATION";
export const GET_NEXT_LESSONS = "GET_NEXT_LESSONS";
export const GET_NEXT_PRONUNCIATIONS = "GET_NEXT_PRONUNCIATIONS";
export const GET_NEXT_TIPS = "GET_NEXT_TIPS";
export const CLEAR_CURRENT_LESSON = "CLEAR_CURRENT_LESSON";
